module.exports = __webpack_public_path__ + "img/userion.908e76b2.svg";